import React from 'react';
import { TimeSelector, NumberInput, Multilingual, TextInput } from 'hyperdb-utils';

const MultilingualTextInput = Multilingual(TextInput);

export default class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {
          this.props.withName
            ? <TextInput
                label="Name *"
                name="name"
                value={ this.props.objectData.name }
                onChange={ this.handleChange.bind(this, 'name') }
              />
            : null
        }
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <fieldset >
              <legend>Min. check-in time</legend>
              <TimeSelector
                label="Min. check-in time"
                name="min_check_in_time"
                value={ this.props.objectData.min_check_in_time }
                onChange={ this.handleChange.bind(this, 'min_check_in_time') }
              />
            </fieldset>
          </div>
          <div className="col-xs-12 col-md-6">
            <fieldset>
              <legend>Max. check-in time</legend>
              <TimeSelector
                label="Max. check-in time"
                name="max_check_in_time"
                value={ this.props.objectData.max_check_in_time }
                onChange={ this.handleChange.bind(this, 'max_check_in_time') }
              />
            </fieldset>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <fieldset>
              <legend>Min. check-out time</legend>
              <TimeSelector
                label="Min. check-out time"
                name="min_check_out_time"
                value={ this.props.objectData.min_check_out_time }
                onChange={ this.handleChange.bind(this, 'min_check_out_time') }
              />
            </fieldset>
          </div>
          <div className="col-xs-12 col-md-6">
            <fieldset>
              <legend>Max. check-out time</legend>
              <TimeSelector
                label="Max. check-out time"
                name="max_check_out_time"
                value={ this.props.objectData.max_check_out_time }
                onChange={ this.handleChange.bind(this, 'max_check_out_time') }
              />
            </fieldset>
          </div>
        </div>
        <br/>
        <MultilingualTextInput
          label="Check-in place"
          name="check_in_place"
          value={ (this.props.objectData.check_in_place || {}).$i18n }
          onChange={ this.handleChangeLocalized.bind(this, 'check_in_place') }
        />
        <NumberInput
          label="Late arrival fee"
          name="late_arrival_fee"
          value={ this.props.objectData.late_arrival_fee }
          onChange={ this.handleChange.bind(this, 'late_arrival_fee') }
        />
        <NumberInput
          label="Early departure fee"
          name="early_departure_fee"
          value={ this.props.objectData.early_departure_fee }
          onChange={ this.handleChange.bind(this, 'early_departure_fee') }
        />
      </div>
    );
  }

  handleChange(attributeName, field) {
    const value = ['early_departure_fee', 'late_arrival_fee'].includes(attributeName) ? parseFloat(field.value || '0') : field.value;
    if (!this.props.onChange) {
      this.props.api.checkInOutRuleset.updateEditedObject({ attributeName, value });
    } else {
      const objectData = { ...this.props.objectData, [attributeName]: value };
      this.props.onChange({ value: objectData });
    }
  }
  handleChangeLocalized(attributeName, field) {
    const localized = field.value;
    this.handleChange(attributeName, { value: { $i18n: localized } });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/check-in-out-ruleset/components/Form.jsx